import axios from 'axios';

const baaderStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    async getWumSecuritiesBySNR(context, snr) {
      return axios
        .get(`${window.BASE_API.BAADER}/data/wdp?snr=${snr}`)
        .then(response => response.data).catch(error => Promise.reject(error));
    },
    async getRKKSecuritiesBySNR(context, snr) {
      return axios
        .get(`${window.BASE_API.BAADER}/data/rkk?snr=${snr}`)
        .then(response => response.data).catch(error => Promise.reject(error));
    },
    async getSecurityTransactionsOfWUM(context, data) {
      return axios
        .get(`${window.BASE_API.BAADER}/data/wum?snr=${data.snr}&wkn=${data.wkn}`)
        .then(response => response.data).catch(error => Promise.reject(error));
    },
    async getPaymentTransactionsOfWKN(context, data) {
      return axios
        .get(`${window.BASE_API.BAADER}/data/rkk?snr=${data.snr}&wkn=${data.wkn}`)
        .then(response => response.data).catch(error => Promise.reject(error));
    },
  },
};

export default baaderStore;



// WEBPACK FOOTER //
// ./src/store/baader/baaderStore.js